
function hostToOrigin(host) {
  return (new URL(host)).origin;
}

function isValidPageMetadata(pageMetadata) {
  if (pageMetadata.constructor !== Object) {
    return false;
  }

  for (const key of Object.keys(pageMetadata)) {
    if ( ![Number, String, Array].includes(pageMetadata[key].constructor)) {
      return false
    }
  }

  return true
}

function getFullUrl(url, host = '') {
  return `${global.metypeHost || host}/${url}`;
}

function getCsrfToken() {
  var content = document.getElementsByName('csrf-token')[0].content
  return content;
}

function isSafari() {
  const userAgent = navigator.userAgent.toLowerCase();
  return userAgent.indexOf('safari') !== -1 && userAgent.indexOf('chrome') === -1
}

function isValidValue(value) {
  return !(value === undefined || value=== null || value === "")
}

// it takes default string(accumulator), array of strings to produce a hypenated string
function hyphenatedString(defaultString='', arrayOfStrings=[]) {
  if(Array.isArray(arrayOfStrings) && arrayOfStrings.length > 0) {
    const reducer = (accumulator, currentValue) => {
      if (isValidValue(currentValue) && isValidValue(accumulator)) {
        return accumulator + "-" + String(currentValue);
      } else {
        return accumulator || '';
      }
    };
    return arrayOfStrings.reduce(reducer, defaultString);
  }
  return ;
}

function numberToAbbreviatedString(value) {
  if(value>=1000000000000) {
    value = (value % 1000000000000 === 0) ? value=(value/1000000000000)+"T" : value=(value/1000000000000).toFixed(1)+"T";
  }
  if(value>=1000000000) {
    value = (value % 1000000000 === 0) ? value=(value/1000000000)+"B" : value=(value/1000000000).toFixed(1)+"B";
  }
  if(value>=1000000) {
    value = (value % 1000000 === 0) ? (value/1000000)+"M" : (value/1000000).toFixed(1)+"M";
  }
  else if(value>=1000) {
    value = (value % 1000 === 0) ? (value/1000)+"K" : (value/1000).toFixed(1)+"K";
  }
  return value;
}

function checkAccountIfConfigIsEnabled(account, config_name) {
  return account.configurations && account.configurations.find((config) => config.name == config_name);
}

function decodeBase64UriEncodedString(string) {
  return decodeURIComponent(atob(string));
}

export {
  hostToOrigin,
  getFullUrl,
  getCsrfToken,
  isSafari,
  isValidValue,
  hyphenatedString,
  isValidPageMetadata,
  numberToAbbreviatedString,
  checkAccountIfConfigIsEnabled,
  decodeBase64UriEncodedString
}



// WEBPACK FOOTER //
// ./app/javascript/util/pure_functions/utils.js